import { GrammarMarkType } from "./enums";

export const BridgeElementKey = "__vgrammar_scene_item__";

export const CollectionMarkType = [ GrammarMarkType.line, GrammarMarkType.area ];

export const Mark3DType = [ GrammarMarkType.arc3d, GrammarMarkType.rect3d, GrammarMarkType.pyramid3d ];

export const DefaultKey = "key";

export const DefaultMarkData = [ {} ];

export const DefaultGroupKeys = [ "key" ];

export const DefaultReuse = !0;

export const DefaultMorph = !0;

export const DefaultMorphAll = !1;

export const DefaultSplitPath = null;

export const DefaultEnableExitAnimation = !0;

export const ImmediateAnimationState = "VGRAMMAR_IMMEDIATE_ANIMATION";

export const DefaultAnimationStartTime = 0;

export const DefaultAnimationDuration = 1e3;

export const DefaultAnimationDelay = 0;

export const DefaultAnimationDelayAfter = 0;

export const DefaultAnimationLoop = !1;

export const DefaultAnimationOneByOne = !1;

export const DefaultAnimationEasing = "quintInOut";

export const DefaultAnimationControlOptions = {
    stopWhenStateChange: !1,
    immediatelyApply: !0
};

export const DefaultAnimationParameters = "VGRAMMAR_ANIMATION_PARAMETERS";

export const MARK_OVERLAP_HIDE_KEY = "_mo_hide_";
//# sourceMappingURL=constants.js.map